<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE897;</i>
          <span>Manage Policy</span>
        </p>
      </div>

      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>Universal Days/Hours of Operation</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content class="exceptionCalendarScreen">
          <form class="example-form" [formGroup]="form">
            <div class="col s12 m6 l6">
              <div class="admSubPageHeading secondlevelSubHeading">
                <p>Start Day & Time</p>
              </div>
              <div class="errorZoneSec">
                <div class="exceptionPageInputSec universalDaysSec">
                  <div class="startDaySec">
                    <md-select placeholder="From" formControlName="startDay">
                      <md-option *ngFor="let days of _utility.weekdays" [value]="days">
                        {{ days.name }}
                      </md-option>
                    </md-select>
                  </div>
                  <div class="startDaySec">

                    <custom-time-control [isDisable]="disableField" formControlName="startTime"></custom-time-control>
                  </div>
                  <div class="startDaySec">
                    <p> UTC Time Zone </p>
                  </div>
                </div>

              </div>
            </div>
            <div class="col s12 m6 l6">
              <div class="admSubPageHeading secondlevelSubHeading">
                <p>End Day & Time</p>
              </div>
              <div class="errorZoneSec">
                <div class="exceptionPageInputSec universalDaysSec">
                  <div class="startDaySec">
                    <md-select placeholder="To" formControlName="endDay">
                      <md-option *ngFor="let days of _utility.weekdays" [value]="days">
                        {{ days.name }}
                      </md-option>
                    </md-select>
                  </div>
                  <p class="validate" *ngIf="form.controls.endDay.invalid">End Day can't be less than Start Day</p>
                  <div class="startDaySec">
                    <custom-time-control [isDisable]="disableField" formControlName="endTime"></custom-time-control>
                  </div>
                  <p class="validate" *ngIf="form.controls.endTime.invalid">End Day can't be less than Start Day</p>
                  <div class="startDaySec">
                    <p> UTC Time Zone </p>
                  </div>

                </div>

              </div>

            </div>

          </form>
        </md-card-content>
        <md-card-actions>
          <div class="button-row">
            <button [disabled]="form.invalid || isEditForm" md-raised-button class="glbAdminBtnCls1" (click)="onAdd()">SAVE</button>
            <button [disabled]="!isEditForm" md-raised-button class="glbAdminBtnCls1" (click)="onEdit()">EDIT</button>
          </div>

          <!--confict grid starts and loaded if any-->
          <div *ngIf="conflictPaginationInfo && conflictPaginationInfo.totalRecords">
            <app-adm-manage-conflict-cases [data]="conflictData"></app-adm-manage-conflict-cases>
          </div>
          <!--conflict grid ends-->

        </md-card-actions>

      </md-card>

    </div>
  </div>
</section>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-universal-operational-hours/adm-manage-universal-operational-hours.component.html